import { REACT_APP_PRIVACY_POLICY_URL } from '../../constants';

const PrivacyPolicy = () => {
  window.location.href = REACT_APP_PRIVACY_POLICY_URL;
  return null;
};

export default PrivacyPolicy;
